<template>
  <div>
    <Button size="large" type="text" @click="backHome">{{ langMap.backHome[lang] }}</Button>
    <Button size="large" type="text" @click="backPrev">{{ langMap.backPrev[lang] }}({{ second }}s)</Button>
  </div>
</template>

<script>
import './error.less'
import langMap from '@/utils/language';
import { mapState } from 'vuex';
export default {
  name: 'backBtnGroup',
  data () {
    return {
      langMap:langMap,
      second: 5,
      timer: null
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
  },
  methods: {
    backHome () {
      this.$router.replace({
        name: this.$config.homeName
      })
    },
    backPrev () {
      this.$router.go(-1)
    }
  },
  mounted () {
    this.timer = setInterval(() => {
      if (this.second === 0) this.backPrev()
      else this.second--
    }, 1000)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>
